export interface INotesHeaderProps {
  title: string;
}

export const NotesHeader = ({ title }: INotesHeaderProps) => {
  return (
    <>
      <h1>{title}</h1>
    </>
  );
};
